// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'

import './assets/myIncon/iconfont.css'
import '@/styles/index.css';

import 'vue-ydui/dist/ydui.base.css';

// 全局提示框dialog
import { Confirm, Alert, Toast, Notify, Loading } from 'vue-ydui/dist/lib.rem/dialog';
Vue.prototype.$dialog = {
    confirm: Confirm,
    alert: Alert,
    toast: Toast,
    notify: Notify,
    loading: Loading,
};

import '@/lib/Extend/Date.Extend';

import Interface from './lib'

Vue.prototype.Interface = Interface

Vue.config.productionTip = false

// import 'vue-ydui/dist/ydui.rem.css';
// import 'vue-ydui/dist/ydui.base.css';
// import 'vue-ydui/dist/ydui.flexible';

new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js